import Experience from "../Experience.js"
import * as THREE from 'three'
import {clamp} from "three/src/math/MathUtils.js"

const near = 22
const far  = 50 // 100

export default class Camera {
    constructor()
    {
        // Setup
        this.experience = new Experience()
        this.input = this.experience.input
        this.sizes = this.experience.sizes
        this.time = this.experience.time
        this.debug = this.experience.debug
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.loader = this.experience.loader
        this.world = null
        this.menu = null

        // Constants
        this.leftQ = new THREE.Quaternion()
        this.rightQ = new THREE.Quaternion()
        this.leftQ.setFromAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI * 9/16)
        this.rightQ.setFromAxisAngle(new THREE.Vector3(0, 1, 0), - Math.PI * 9/16)
        this.yAxis = new THREE.Vector3(0, 1, 0)

        // Camera Resting Position
        this.restingPos = new THREE.Vector3()
        this.restingRot = new THREE.Quaternion()
        this.direction = 0

        // Instantiate Camera
        this.setInstance()
        this.setDebug()

        // Events
        this.loader.on('ready', () => {
            this.world = this.experience.world

            this.world.on('menuLoaded', () => {
                this.menu = this.experience.world.menu

                this.menu.on('moveLeft', () => this.onMoveLeft())
                this.menu.on('moveToMenu', () => this.onMoveToMenu())
            })
        })
    }

    // Instantiate Camera
    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(75, this.sizes.width / this.sizes.height, 0.1, 100)
        this.instance.position.set(0, 0, 20)
        this.instance.rotation.order = "YXZ"
        this.instance.rotation.x = Math.PI / 32

        this.restingPos.copy(this.instance.position)
        this.restingRot.copy(this.instance.quaternion)

        // Set distance based on canvas aspect
        if(this.sizes.width / this.sizes.height > 1.38)
        {
            this.restingPos.z = 17
        }
        else {
            this.restingPos.z = clamp(1391 * near/ this.sizes.width, near, far)
        }

        this.scene.add(this.instance)
    }


    // Callback Methods

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()

        if(this.sizes.width / this.sizes.height > 1.38)
        {
            if(this.direction == -1)
            {
                this.restingPos.x = -35
            }
            else {
                this.restingPos.z = 17
            }
        }
        else {
            if(this.direction == -1)
            {
                this.restingPos.x = clamp(-20 * this.sizes.width / this.sizes.height, -35, 10)
            }
            else {
                this.restingPos.z = clamp(1391 * near/ this.sizes.width, near, far)
            }
        }
    }

    update()
    {
        if(this.time.visible)
        {
            const delta = this.time.delta * 0.001
            this.updatePosition(delta)
            this.updateRotation(delta)
        }
    }

    onMoveLeft()
    {
        this.restingPos.set(-35, 0, 17)
        this.restingRot.setFromAxisAngle(this.yAxis, Math.PI * 9/16)
        this.direction = -1
        if(this.sizes.width / this.sizes.height < 1.38)
        {
            this.restingPos.x = clamp(-20 * this.sizes.width / this.sizes.height, -35, 10)
        }
    }

    onMoveToMenu()
    {
        this.restingPos.set(0, 0, 17)
        this.restingRot.setFromAxisAngle(this.yAxis, 0)
        this.direction = 0
        if(this.sizes.width / this.sizes.height < 1.38)
        {
            this.restingPos.z = clamp(1391 * near/ this.sizes.width, near, far)
        }
    }


    // Helper Methods

    updatePosition(deltaTime)
    {
        const parallax = new THREE.Vector3(
            this.restingPos.x + this.input.cursor.x * 2,
            this.restingPos.y + this.input.cursor.y * 2,
            this.restingPos.z
        )

        const parallaxLeft = new THREE.Vector3(
            this.restingPos.x, 
            this.restingPos.y + this.input.cursor.y * 2,
            this.restingPos.z + this.input.cursor.x * 2
        )

        if(this.direction == -1)
        {
            this.instance.position.lerp(parallaxLeft, 2 * deltaTime)
        }
        else {
            this.instance.position.lerp(parallax, 2 * deltaTime)
        }
    }

    updateRotation(deltaTime)
    {
        //TODO: listen for description open, right, left, rotation only
        const rotation = new THREE.Euler()
        const resting = new THREE.Euler()
        rotation.order = "YXZ"
        resting.order = "YXZ"
        resting.setFromQuaternion(this.restingRot)

        // Rotate at edges
        if(Math.abs(this.input.cursor.x) > 0.45)
        {
            rotation.y = (-this.input.cursor.x * 0.1) + resting.y
        }
        else {
            rotation.y = resting.y
        }

        if(Math.abs(this.input.cursor.y) > 0.45)
        {
            rotation.x = (this.input.cursor.y * 0.1) + Math.PI/32
        }
        else {
            rotation.x = Math.PI/32
        }

        const quatRotation = new THREE.Quaternion()
        quatRotation.setFromEuler(rotation)

        this.instance.quaternion.slerp(quatRotation, 2 * deltaTime)
    }

    // Debug
    setDebug() {
        if(this.debug.active)
        {
            this.debug.ui.add(this.restingRot, 'y', -Math.PI * 2, Math.PI * 2, Math.PI/32)
                      .name("Rotation")
        }
    }
}